import React from 'react'
import { Columns, Option } from '../../../shared/EditableTable/Model'

export default function initialDataExportEarningMilestoneReport(options: Option<string>[]) {
  const toNumber = (anything: any) => {
    const tempNumber = Number(anything)
    return isNaN(tempNumber) ? 0 : tempNumber
  }
  const columns: Columns[] = [
    {
      id: 'countryCrmID',
      label: 'Country',
      accessor: 'countryCrmID',
      dataType: 'select',
      options,
      Footer: 'Total:',
    },
    {
      id: 'expenses',
      label: 'Expenses A$',
      accessor: 'expenses',
      dataType: 'number',
      Footer: ((info: { rows: number[]; }) => {
        const total = React.useMemo(
          () => info.rows.reduce((sum: number, row: any) => toNumber(row.values.expenses) + sum, 0),
          [info.rows],
        )
        return <>{total.toFixed(2)}</>
      }),
    },
    {
      id: 'earnings',
      label: 'Earnings A$',
      accessor: 'earnings',
      dataType: 'number',
      Footer: ((info: { rows: number[]; }) => {
        const total = React.useMemo(
          () => info.rows.reduce((sum: number, row: any) => toNumber(row.values.earnings) + sum, 0),
          [info.rows],
        )
        return <>{total.toFixed(2)}</>
      }),
    },
    {
      id: 'remove',
      label: 'Remove',
      accessor: 'remove',
      dataType: 'remove',
      minWidth: 70,
      width: 70,
    },
  ]
  return { columns, skipReset: false }
}
